import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertToUserTimezone = (dateString, timeString, timezone, extract) => {
  try {
    const datePartOnly = dateString?.split('T')[0];
    const utcDateTimeString = `${datePartOnly}T${timeString}Z`;
    const utcDateTime = new Date(utcDateTimeString);
    if (isNaN(utcDateTime)) {
      console.error('Invalid Date-Time:', datePartOnly, timeString);
      return '';
    }
    const userDateTime = dayjs.utc(utcDateTime).tz(timezone);
    const formattedDate = userDateTime.format('YYYY-MM-DD');
    const formattedTime = userDateTime.format('HH:mm:ss');
    return extract === 'date'
      ? formattedDate
      : extract === 'time'
        ? formattedTime
        : { date: formattedDate, time: formattedTime };
  } catch (error) {
    console.error('Error converting to user timezone:', error);
    return '';
  }
};
